import { useHistory } from "react-router-dom";
import Button from "components/Button";
import * as S from "./styles";

export function NotFound() {
  const history = useHistory();
  return (
    <S.Container>
      <S.Content>
        <h4>Erro 404</h4>
        <h1>
          Não encontramos
          <br />
          essa página
        </h1>
        <p>
          Algo deu errado.
          <br />
          Sugerimos voltar para a home
        </p>
        <Button
          title="Voltar ao início"
          onClick={() => {
            history.push("/home");
          }}
        />
      </S.Content>
    </S.Container>
  );
}
